<template>
    <div class="control">
       <div class="toolbar-item icon-button " @click="$_open()">
            <Open size="24" />
        </div>
        <ul class="editbutton ul_tools ">
            <li v-for="item in fileList"
                :key="item.index"
                :title="item.title"
                :id="item.name"
                @click.stop="btn(item.name) ">
                <el-divider v-if="item.class=='divider'" class="iconfont icon-button " direction="vertical"></el-divider>
                <span v-else :class="item.class +' '+ item.pic+'  '"  :style="item.style"></span>
            </li>
        </ul>

        <div title="导出文件" class="toolbar-item icon-button "  @click="$_daochu">
            <daochu size="22" />
        </div>
        <div title="导入文件" class="toolbar-item icon-button "  @click="$_daoru">
            <daoru size="22" />
        </div>
        <div title="导出图片"
                class="toolbar-item icon-button "
                @click="$_saveGraph"
        >
            <DaochuPic size="24" />
        </div>
       <div title="选取" class="toolbar-item icon-button selection"  @click="$_selectionSelect()">
            <area-select size="22" />
        </div>

        <div title="放大" class="toolbar-item icon-button " @click="$_zoomIn()">
            <zoom-in size="22"  />
        </div>
        <div title="缩小" class="toolbar-item icon-button " @click="$_zoomOut()">
            <zoom-out size="22" />
        </div>
        <div title="上一步"
                class="toolbar-item icon-button"
                :class="{'disabled': !undoAble}"
                @click="$_undo()"
        >
            <step-back size="22" />
        </div>
        <div title="下一步"
                class="toolbar-item icon-button"
                :class="{'disabled': !redoAble}"
                @click="$_redo()"
        >
            <step-foward size="22" />
        </div>

        <div title="设置"
                class="toolbar-item icon-button dataset"
                @click="$_dataset()"
        >
            <DataSet size="24" />
        </div>
        <div title="多语言标签"
             class="toolbar-item icon-button multlabel"
             @click="$_multlabel()"
        >
            <I18Icon size="24" />
        </div>


        <el-popover ref="pop_list"
                    placement="bottom-end"
                    popper-class="pop_list_content"
                    trigger="click"
        >
            <flowlist ref="flowlist"  :flowlist="flowlistdata" @pagechange="loadFlowList" @flowselect="$_flowSelect" style="height:100%;width:100%;"  ></flowlist>
        </el-popover>
        <el-popover ref="pop_info"
                    :append-to-body="false"
                    :popper-options="{
                      boundariesElement: 'body',
                      gpuAcceleration: true,
                      positionFixed: true,
                      preventOverflow: true
                    }"
                    placement="bottom-end"
                    popper-class="set_pop_info"
                    trigger="click">
            <Info   ref="info" @infoedit="$_flowSetChange"></Info>
        </el-popover>
        <fdialog  ref="mydialog"   ></fdialog>
        <input type="file" style="display:none"  name="upload_file" ref="upload_file" id="upload_file" @change="importFile"/>
        <el-dialog
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                :class="baseerp+'div'"
                top="5vh"
                width="90%"
                title="列表"
                :visible.sync="dialogVisible_mult"
                :close-on-click-modal="false"
                @close="cancelDialog"
                v-if="dialogVisible_mult"
                :append-to-body="true">
            <mult-list ref="costlist" :maxH="maxDialogHeight"  @close="cancelDialog"></mult-list>
        </el-dialog>
    </div>
</template>

<script>

    import * as flowUtil from '@/utils/logicFlowJs.js';
    import fdialog from "@/components/dialog"; // dialog
    import Info from '../PropertySetting/Info'
    import flowlist from '../flowList/flowlist'

    import Open from '../icon/Open.vue'
    import ZoomIn from '../icon/ZoomIn.vue'
    import ZoomOut from '../icon/ZoomOut.vue'
    import StepBack from '../icon/StepBack.vue'
    import StepFoward from '../icon/StepFoward.vue'
    import AreaSelect from '../icon/AreaSelect.vue'
    import Daochu from '../icon/daochu.vue'
    import Daoru from '../icon/daoru.vue'
    import DataSet from '../icon/DataSet.vue'
    import DaochuPic from '../icon/daochupic.vue'
    import I18Icon from '../icon/i18Icon'
    import MultList from './MultList'
    import {baseerp} from "@/utils/baseUrl";
    const newData = require('./new.json')
    export default {
        props: {
            lf: Object,

        },
        components: {
            fdialog,
           flowlist,
            Info,
            Open,
            ZoomIn,
            ZoomOut,
            StepBack,
            StepFoward,
            AreaSelect,
            Daochu,
            Daoru,
            DataSet,
            DaochuPic,
            I18Icon,
            MultList,
        },
        data () {
            return {
                ctrlType:"flow",
                flowSet:{},
                flowdata:{},
                flowlistdata:{},
                selectionOpened: false,
                undoAble: false,
                redoAble: false,

                colors: '#345678',
                linetype: 'polyline',
                 fileList:{divider:{class:'divider'},new:{name:'new',title:'新建',data:1,style:'padding:4px ;font-size:26px',pic:'icon-wenjian1',class:'font-button iconfontcolor'},newCopy:{name:'copy',title:'复制新建',data:1,style:'padding:4px;font-size:26px',pic:'icon-light-component-filedeal-copyfile',class:'font-button iconfontcolor'},save:{name:'save',title:'保存',data:1,style:'padding:2px 1px;font-size:28px',pic:'icon-autosave',class:'font-button iconfontcolor'}},
                maxDialogHeight:0,
                dialogVisible_mult:false,
                baseerp:"",
            }
        },
        mounted () {
            this.baseerp=baseerp;
            this.$props.lf.on('history:change', ({ data: { undoAble, redoAble } }) => {
                this.$data.redoAble = redoAble
                this.$data.undoAble = undoAble
            })
            this.setDialogHeight();
            window.addEventListener('resize', this.setDialogHeight);

            //
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setDialogHeight);
        },
        methods: {
            cancelDialog(){
              this.dialogVisible_mult=false
              $(".multlabel").removeClass("font-checked");
            },
            setDialogHeight() {
                //console.log(window.innerHeight,'window.innerHeight')
                this.maxDialogHeight = window.innerHeight;
            },
            $_render(data) {
                this.$props.lf.render(data)
            },
            $_open() {
                 if (this.$refs.pop_list.showPopper)
                     this.$refs.pop_list.showPopper=false
                else
                 this.loadFlowList(1);

            },
            $_daochu() {
                //生成时间戳
                var fileName = new Date().getTime() + '.flow';

                let set=this.$refs.info.getData();
                this.flowdata.file_json = this.$props.lf.getGraphData();
                this.flowdata.file_json.set=set;
                this.flowdata.fileType="flow";
                var jsontext = JSON.stringify(this.flowdata);
                saveAs(new Blob([jsontext], {type: "text/plain;charset=utf-8"}), fileName);
            },
            $_daoru() {
                this.$refs.upload_file.dispatchEvent(new MouseEvent('click'));
            },

            importFile() {

                var file = document.getElementById("upload_file").files[0];
                var fileName = file.name;
                var index = fileName.lastIndexOf('.');
                var fileExt = fileName.substr(index + 1).toLowerCase();
                if (fileExt === 'flow') {
                    this.importFromJSON(file)
                }
                $("#upload_file").val("");
            },
            importFromJSON(file) {

                var _this=this;
                function importSuccessCallback(responseText) {
                    let fjson=JSON.parse(responseText);
                    var json=fjson.file_json;
                    _this.$_reset();
                    let set=json.hasOwnProperty("set")?json.set:{};
                    _this.flowSet.params=set.params;
                    _this.flowSet.desc=set.desc;
                    _this.flowSet.mainTable=set.mainTable;
                    _this.flowSet.mainId=set.mainId;
                    _this.flowSet.subTable=set.subTable;
                    let graphData={};
                    graphData.nodes=json.nodes;
                    graphData.edges=json.edges;
                    _this.flowdata.file_json = graphData;
                    _this.$refs.pop_info.showPopper =true;
                    _this.$refs.info.init(_this.flowSet);
                    _this.$emit('setFlowData',_this.flowSet);
                    _this.$_render(graphData);
                    _this.$message.success("导入成功");
                }

                var reader = new FileReader();
                reader.onload = function () {
                    importSuccessCallback(this.result);
                };
                reader.readAsText(file);
                return true;
            },
            $_reset(){
                this.$props.lf.resetZoom();
                this.$props.lf.resetTranslate();
            },
            $_saveGraph() {
                this.$props.lf.getSnapshot();

            },
            $_zoomIn() {
                this.$props.lf.zoom(true)
            },
            $_zoomOut() {
                this.$props.lf.zoom(false)
                let param = {"stepid": 35450,"table":"jxc_j_main", "mdKey": "","busType":"normal","data":{}};
                this.stepTest(param);
            },
            $_undo() {
                if (this.$data.undoAble) {
                    this.$props.lf.undo()

                }
            },
            $_redo() {
                if (this.$data.redoAble) {
                    this.$props.lf.redo()
                }
            },
            $_multlabel(){

                if($(".multlabel").hasClass("font-checked"))
                {
                    $(".multlabel").removeClass("font-checked");
                    this.dialogVisible_mult=false;

                }
                else {
                    $(".multlabel").addClass("font-checked");
                    this.dialogVisible_mult=true;
                }
            },

            $_dataset(a) {
                if($(".dataset").hasClass("font-checked") && a==undefined)
                {
                    $(".dataset").removeClass("font-checked");
                    this.$refs.pop_info.showPopper = false;

                }
                else {
                    $(".dataset").addClass("font-checked");

                    this.$refs.pop_info.showPopper = true;
                }
            },
            $_selectionSelect() {
                if($(".selection").hasClass("font-checked"))
                {
                    $(".selection").removeClass("font-checked");
                    this.lf.extension.selectionSelect.closeSelectionSelect()

                }
                else {
                    $(".selection").addClass("font-checked");

                    this.lf.extension.selectionSelect.openSelectionSelect()
                }


            },
            $_changeLineType(value) {
                const {lf, activeEdges} = this.$props
                const {graphModel} = lf
                lf.setDefaultEdgeType(value)
                if (activeEdges && activeEdges.length > 0) {
                    activeEdges.forEach(edge => {
                        graphModel.changeEdgeType(edge.id, value)
                    })
                }
            },

            closeShow(){
                this.$refs.pop_list.showPopper =false;
            },
            btn(id) {
                if (id == undefined) return;
                let id_family = id.split("-");
                let sid = id_family[1];
                switch (id_family[0]) {
                    case 'save':
                        this.saveFlowTemplate()
                        break;
                    case 'new':
                        this.$_reset();
                        this.$refs.pop_info.showPopper =true;
                        this.flowSet={};
                        this.$refs.info.init({});
                        let newflow={"id":0,"filename":"未命名","fid":"","fileType":"flow","file_json":{}};
                        this.flowdata=newflow;
                        this.$_render(newData);
                        this.$_dataset(1);
                        this.$props.lf.history.redos=[];
                        this.$props.lf.history.undos=[];
                        break;
                    case 'copy':
                        this.flowdata.fid="";
                        this.flowSet.text="未命名";
                        this.$refs.info.init( this.flowSet);
                        this.$emit('setFlowData',this.flowSet);
                        this.$props.lf.history.redos=[];
                        this.$props.lf.history.undos=[];
                        this.$_dataset(1);
                        this.$message.success("新建并拷贝完成");
                        break;
                    default:

                        break;
                }
            },

            //load报表模板
            async loadTemplateFromSvr(fid) {
                this.$props.lf.history.redos=[];
                this.$props.lf.history.undos=[];
                let param = {"fid": fid};
                let res = await flowUtil.loadDataFromSvr(param);
                if (res.code == 1) {
                    this.$_reset();
                    let json=res.json;
                    let set=json.hasOwnProperty("set")?json.set:{};
                    let graphData={};
                    graphData.nodes=json.nodes;
                    graphData.edges=json.edges;
                    this.flowdata.file_json = graphData;
                    this.flowdata.filename = res.name;
                    this.flowdata.i_id=res.id;
                    this.flowdata.fid = fid;
                    this.$refs.info.init(set);
                    this.flowSet=set;
                    this.$emit('setFlowData',set);
                    this.$_render(graphData);


                } else {
                     this.$refs.mydialog.showDialog({type:"error",text:"流程加载失败!("+res.message+")",info:res.error});
                }
            },
            //load报表模板
            async saveFlowTemplate() {
                let set=this.$refs.info.getData();
                this.flowdata.file_json = this.$props.lf.getGraphData();
                this.flowdata.file_json.set=set;
                this.flowdata.fileType="flow";

                let res = await flowUtil.saveFlowTemplate(this.flowdata);
                if (res.code == 1) {
                    this.$message.success("保存成功");

                } else {
                    this.$refs.mydialog.showDialog({type:"error",text:"流程保存失败!("+res.message+")",info:res.error});
                }
            },

            //loadFlow模板
            async loadFlowList(page) {
                let param = {"page_size": page, "page_count": 10};
                let res = await flowUtil.loadFlowList(param);
                if (res.code == 1) {
                    this.flowlistdata=res;
                    this.$refs.pop_list.showPopper =true;
                } else {
                    this.$refs.mydialog.showDialog({type:"error",text:"流程列表加载失败!("+res.message+")",info:res.error});
                }
            },

            //load报表模板
            async flowTest(p) {
                let res = await flowUtil.getFlowNodeState(p);
                if (res.code == 1) {
                    //console.log("ok", res)

                } else {
                    this.$message.error(res.message);
                }
            },
             $_flowSelect(id){
                 this.loadTemplateFromSvr(id);
            },
            $_flowSetChange(set){
                this.flowSet=set;
                this.$emit('setFlowData',set);
            }
        }
    }
</script>

<style scoped>
    /deep/ .el-dialog__body{
        padding: 14px;
    }
    .ul_tools {
        display: flex;
        float: left;
    }

    .control {
        height:38px;
        display: flex;
        float: left;
    }

    .toolbar-item {
        text-align: center;

        display: flex;
        float: left;
        margin: 3px 3px;

        width:28px;
        height:28px;
        cursor: pointer;
    }
    .icon-button:hover {
        background: #d3d3d3;

    }
    .icon{
        fill: #016277;
        padding: 3px 3px;
        align-content: center;
    }
    .font-button {
        margin-top:5px;
        padding: 3px 3px;
        color: #016277;
        font-size: 14pt;
        outline: none;
        cursor: pointer;
        text-align: center;
        line-height:36px;

    }
    .font-checked {
        background: #f6e3ac;

    }
    .font-button:hover {
        background: #babdbf;
        pointer-events:auto;
    }
    .font-disable {
        opacity: 0.5;
        pointer-events:none;
    }

    .select_item{
        font-size: 9px;
    }


</style>
